import React from 'react'
import CountUp from 'react-countup'
import { isMobile } from 'react-device-detect'
import { Me } from 'service/user'
import { UserType } from 'utils/common'
import { ShortFormButton } from './button/ShortFormButton'

export const ShortFormType = ({
  handlePayment,
  totalCount,
  handleCopyClipBoard,
  handleDownload,
  handleDownloadAll,
  userInfo,
  getPaymentOrderRequests,
}: {
  handlePayment: () => void
  totalCount: number
  handleCopyClipBoard: (copyText: string, successText: string) => void
  handleDownload: (url: string, index: number) => void
  handleDownloadAll: () => void
  userInfo: Me
  getPaymentOrderRequests: (planId: number, planPriceId: number) => void
}) => {
  return (
    <>
      {isMobile ? (
        <>
          <div
            className="image1 w-[375px] bg-cover bg-center h-[645px] flex flex-col justify-end  "
            style={{
              backgroundImage:
                "url('https://s3.ap-northeast-2.amazonaws.com/pub.angelleague.io/fast_cut_front/challenge/short_form_gift_mobile.png')",
            }}
          >
            <div className="flex w-full h-full items-end justify-center">
              <button onClick={handlePayment} className="mb-3">
                {' '}
                <img src="assets/img/fast-short-buy-mobile.png" alt="" />
              </button>
            </div>
          </div>
        </>
      ) : (
        <>
          <div
            className="image1 w-full bg-cover bg-center md:h-[686px] flex flex-col justify-between"
            style={{
              backgroundImage:
                "url('https://s3.ap-northeast-2.amazonaws.com/pub.angelleague.io/fast_cut_front/challenge/short_form_gift.png')",
            }}
          >
            <div className="flex w-full h-full items-end justify-center">
              <button onClick={handlePayment} className="mb-3">
                <img src="assets/img/fast-short-buy.png" alt="" />
              </button>
            </div>
          </div>
        </>
      )}
      {isMobile ? (
        <>
          <div
            className="image1 w-[375px] bg-cover bg-center  h-[1261px] flex justify-center items-end"
            style={{
              backgroundImage:
                "url('https://s3.ap-northeast-2.amazonaws.com/pub.angelleague.io/fast_cut_front/challenge/image1_mobile_button_type.jpg')",
            }}
          ></div>
        </>
      ) : (
        <>
          <div
            className="image1 w-full bg-cover bg-center h-[1324px] flex justify-center items-end bg-[#181830]"
            style={{
              backgroundImage:
                "url('https://s3.ap-northeast-2.amazonaws.com/pub.angelleague.io/fast_cut_front/challenge/image1_button_type.jpg')",
            }}
          ></div>
        </>
      )}

      {isMobile ? (
        <>
          <div
            className="challenge-div2 w-full bg-cover bg-center h-[584px] flex "
            style={{
              backgroundImage:
                "url('https://s3.ap-northeast-2.amazonaws.com/pub.angelleague.io/fast_cut_front/challenge/image2_mobile_button_type.jpg')",
            }}
          ></div>
        </>
      ) : (
        <>
          <div
            className="challenge-div2 w-full bg-cover bg-center h-[584px] flex "
            style={{
              backgroundImage:
                "url('https://s3.ap-northeast-2.amazonaws.com/pub.angelleague.io/fast_cut_front/challenge/image2_button_type.jpg')",
            }}
          ></div>
        </>
      )}
      {isMobile ? (
        <>
          {' '}
          <div
            className="challenge-div2-mobile w-[375px] bg-cover bg-center h-[1113px] flex "
            style={{
              backgroundImage:
                "url('https://s3.ap-northeast-2.amazonaws.com/pub.angelleague.io/fast_cut_front/challenge/short_form_challenge2_mobile.jpg')",
            }}
          ></div>
        </>
      ) : (
        <>
          {' '}
          <div
            className="challenge-div2 w-full bg-cover bg-center h-[1088px] flex "
            style={{
              backgroundImage:
                "url('https://s3.ap-northeast-2.amazonaws.com/pub.angelleague.io/fast_cut_front/challenge/short_form_challenge2.jpg')",
            }}
          ></div>
        </>
      )}
      {/* <div className="challenge-div2 w-full  h-[793px] flex flex-col items-center py-5 gap-4">
            <p className="font-[500] text-[24px] text-white text-center leading-[29px]">
              조회수 얼마 안나올 거 <br />
              <span
                className="font-bold text-[36px]"
                style={{ textEmphasis: 'filled white' }}
              >
                알면서
              </span>
            </p>
            <p className="text-[24px] font-bold text-[#FFE89E] text-center">
              잠 줄여가며 몇 시간 들여 <br />
              대본 쓰고 편집하고 자막 넣는
            </p>
            <div className="w-full flex flex-col items-center">
              <p>
                <img
                  src="assets/img/icon_youtube.png"
                  alt="icon"
                  className="w-[66px] h-[66px]"
                  loading="lazy"
                />
              </p>
              <p className="text-white font-[800] font-[Tenada] text-[50.43px]">
                유튜브 영상 작업
              </p>
              <p
                className="w-[3px] h-[122px]"
                style={{
                  background: `linear-gradient(to bottom, rgba(255, 255, 255, 0),rgba(255, 255, 255, 1),rgba(255, 255, 255, 1))`,
                }}
              ></p>
              <p className="text-white font-[800] font-[Tenada] text-[50.43px]">
                지겹지 않나요?
              </p>
              <p>
                <img
                  src="https://s3.ap-northeast-2.amazonaws.com/pub.angelleague.io/fast_cut_front/challenge/sleep.jpg"
                  alt="sleep"
                  className="w-[335px] h-[228px]"
                  loading="lazy"
                />
              </p>
            </div>
          </div> */}
      <div
        className="challenge-div3 w-full bg-cover bg-center h-[1392px] flex "
        style={{
          backgroundImage:
            "url('https://s3.ap-northeast-2.amazonaws.com/pub.angelleague.io/fast_cut_front/challenge/review.jpg')",
        }}
      ></div>
      <div
        className="challenge-div4 w-full bg-cover bg-center h-[537px] flex "
        style={{
          backgroundImage:
            "url('https://s3.ap-northeast-2.amazonaws.com/pub.angelleague.io/fast_cut_front/challenge/image4.jpg')",
        }}
      ></div>
      <div className="challenge-div5 w-full bg-cover bg-center h-[342px] flex flex-col items-center justify-center bg-[#2E343D]">
        <p className="text-white text-[24px]">서비스 오픈 3개월만에</p>
        <p className="text-white font-[800] text-[40px] text-center">
          패스트컷에서 <br />
          생성된 리뷰영상
        </p>
        <p className="text-[#608BFF] font-[800]  text-[40px]">
          {' '}
          <span className=" text-[76px]">
            <CountUp end={totalCount} duration={2} separator="," />
          </span>
          개
        </p>
      </div>
      <div
        className="challenge-div6 w-full bg-cover bg-center h-[692px] flex "
        style={{
          backgroundImage:
            "url('https://s3.ap-northeast-2.amazonaws.com/pub.angelleague.io/fast_cut_front/challenge/short_form_image6.jpg')",
        }}
      ></div>
      {isMobile ? (
        <>
          {' '}
          <div
            className="challenge-div7-mobile w-[375px] bg-cover bg-center h-[351px] flex "
            style={{
              backgroundImage:
                "url('https://s3.ap-northeast-2.amazonaws.com/pub.angelleague.io/fast_cut_front/challenge/image7_mobile.jpg')",
            }}
          ></div>
        </>
      ) : (
        <>
          {' '}
          <div
            className="challenge-div7 w-full bg-cover bg-center h-[351px] flex "
            style={{
              backgroundImage:
                "url('https://s3.ap-northeast-2.amazonaws.com/pub.angelleague.io/fast_cut_front/challenge/image7.jpg')",
            }}
          ></div>
        </>
      )}
      {isMobile ? (
        <>
          {' '}
          <div
            className="challenge-div8-mobile w-[375px] bg-cover bg-center h-[847px] flex "
            style={{
              backgroundImage:
                "url('https://s3.ap-northeast-2.amazonaws.com/pub.angelleague.io/fast_cut_front/challenge/image8_mobile.jpg')",
            }}
          ></div>
        </>
      ) : (
        <>
          {' '}
          <div
            className="challenge-div8 w-full bg-cover bg-center h-[818px] flex "
            style={{
              backgroundImage:
                "url('https://s3.ap-northeast-2.amazonaws.com/pub.angelleague.io/fast_cut_front/challenge/image8.jpg')",
            }}
          ></div>
        </>
      )}
      {isMobile ? (
        <>
          {' '}
          <div
            className="challenge-div8-mobile w-[375px] bg-cover bg-center h-[814px] flex "
            style={{
              backgroundImage:
                "url('https://s3.ap-northeast-2.amazonaws.com/pub.angelleague.io/fast_cut_front/challenge/image8-1_mobile.jpg')",
            }}
          ></div>
        </>
      ) : (
        <>
          {' '}
          <div
            className="challenge-div8 w-full bg-cover bg-center h-[759px] flex "
            style={{
              backgroundImage:
                "url('https://s3.ap-northeast-2.amazonaws.com/pub.angelleague.io/fast_cut_front/challenge/image8-1.jpg')",
            }}
          ></div>
        </>
      )}
      {isMobile ? (
        <>
          {' '}
          <div
            className="challenge-div8-mobile w-[375px] bg-cover bg-center h-[1104px] flex "
            style={{
              backgroundImage:
                "url('https://s3.ap-northeast-2.amazonaws.com/pub.angelleague.io/fast_cut_front/challenge/image8-2_mobile.png')",
            }}
          ></div>
        </>
      ) : (
        <>
          {' '}
          <div
            className="challenge-div8 w-full bg-cover bg-center h-[948px] flex "
            style={{
              backgroundImage:
                "url('https://s3.ap-northeast-2.amazonaws.com/pub.angelleague.io/fast_cut_front/challenge/image8-2.png')",
            }}
          ></div>
        </>
      )}
      {isMobile ? (
        <>
          {' '}
          <div className="challenge-div9-mobile w-[375px]   flex relative h-[526px]">
            <img
              src="https://s3.ap-northeast-2.amazonaws.com/pub.angelleague.io/fast_cut_front/challenge/image9_mobile.jpg"
              alt="img"
              className="w-full   h-[576px] absolute -top-12"
              loading="lazy"
            />
          </div>
        </>
      ) : (
        <>
          {' '}
          <div className="challenge-div9 w-full   flex relative h-[576px] bg-[#2E343D]">
            <img
              src="https://s3.ap-northeast-2.amazonaws.com/pub.angelleague.io/fast_cut_front/challenge/image9.jpg"
              alt="img"
              className="w-full   h-[576px] absolute -top-12"
              loading="lazy"
            />
          </div>
        </>
      )}
      <div
        className="challenge-div10 w-full bg-cover bg-center h-[1124px] flex "
        style={{
          backgroundImage:
            "url('https://s3.ap-northeast-2.amazonaws.com/pub.angelleague.io/fast_cut_front/challenge/image10.jpg')",
        }}
      ></div>

      {isMobile ? (
        <>
          {' '}
          <div
            className="challenge-div13-mobile w-[375px] bg-cover bg-center h-[955px] flex "
            style={{
              backgroundImage:
                "url('https://s3.ap-northeast-2.amazonaws.com/pub.angelleague.io/fast_cut_front/challenge/image13_mobile.jpg')",
            }}
          ></div>
        </>
      ) : (
        <>
          {' '}
          <div
            className="challenge-div13 w-full bg-cover bg-center h-[955px] flex "
            style={{
              backgroundImage:
                "url('https://s3.ap-northeast-2.amazonaws.com/pub.angelleague.io/fast_cut_front/challenge/image13.jpg')",
            }}
          ></div>
        </>
      )}
      {isMobile ? (
        <>
          {' '}
          <div
            className="challenge-div14 w-full bg-cover bg-center h-[684px] flex "
            style={{
              backgroundImage:
                "url('https://s3.ap-northeast-2.amazonaws.com/pub.angelleague.io/fast_cut_front/challenge/image14_mobile.jpg')",
            }}
          ></div>
        </>
      ) : (
        <>
          {' '}
          <div
            className="challenge-div14 w-full bg-cover bg-center h-[694px] flex "
            style={{
              backgroundImage:
                "url('https://s3.ap-northeast-2.amazonaws.com/pub.angelleague.io/fast_cut_front/challenge/image14.jpg')",
            }}
          ></div>
        </>
      )}
      {isMobile ? (
        <>
          {' '}
          <div
            className="challenge-div15 w-[375px] bg-cover bg-center h-[2001px] flex"
            style={{
              backgroundImage:
                "url('https://s3.ap-northeast-2.amazonaws.com/pub.angelleague.io/fast_cut_front/challenge/image15_mobile.jpg')",
            }}
          ></div>
        </>
      ) : (
        <>
          <div
            className="challenge-div15 w-full bg-cover bg-center h-[1911px] flex "
            style={{
              backgroundImage:
                "url('https://s3.ap-northeast-2.amazonaws.com/pub.angelleague.io/fast_cut_front/challenge/image15.jpg')",
            }}
          ></div>
        </>
      )}

      {isMobile ? (
        <>
          {' '}
          <div
            className="image3_mobile w-[375px] bg-cover bg-center flex items-end h-[662px]"
            style={{
              backgroundImage:
                "url('https://s3.ap-northeast-2.amazonaws.com/pub.angelleague.io/fast_cut_front/challenge/discount_mobile_image.jpg')",
            }}
          >
            <div className="caution 4 w-[375px] flex justify-center gap-4 mb-[30px]">
              <button
                className=" text-[#222222] text-[18px]  w-[315.66px] h-[56.54px] rounded-[60px] border-[2px] border-[#FFFFFF66] font-bold border-opacity-50 "
                style={{
                  background:
                    'linear-gradient(to top, rgba(229, 169, 7, 1),rgba(237, 224, 147, 1))',
                  border: '2px solid rgba(255, 255, 255 , 0.4)',
                }}
                onClick={handlePayment}
              >
                지금 할인 받고 결제하기 {`>`}
              </button>
            </div>
          </div>
        </>
      ) : (
        <>
          {' '}
          <div
            className="image3 w-full bg-cover bg-center h-[695px] flex items-end"
            style={{
              backgroundImage:
                "url('https://s3.ap-northeast-2.amazonaws.com/pub.angelleague.io/fast_cut_front/challenge/discount_image.jpg')",
            }}
          >
            <div className="caution 4 w-full flex justify-center gap-4  mb-8">
              <button
                className=" text-[#222222] text-[18px]  w-[315.66px] h-[56.54px] rounded-[60px] font-bold  "
                style={{
                  background:
                    'linear-gradient(to top, rgba(229, 169, 7, 1),rgba(237, 224, 147, 1))',
                  border: '2px solid rgba(255, 255, 255, 0.4)',
                }}
                onClick={handlePayment}
              >
                지금 할인 받고 결제하기 {`>`}
              </button>
            </div>
          </div>
        </>
      )}

      {isMobile ? (
        <>
          {' '}
          <div
            className="challenge-div19 w-[375px] bg-cover bg-center h-[1201px] flex "
            style={{
              backgroundImage:
                "url('https://s3.ap-northeast-2.amazonaws.com/pub.angelleague.io/fast_cut_front/challenge/short_form_image19_mobile.jpg')",
            }}
          ></div>
        </>
      ) : (
        <>
          {' '}
          <div
            className="challenge-div19 w-full bg-cover bg-center h-[1201px] flex "
            style={{
              backgroundImage:
                "url('https://s3.ap-northeast-2.amazonaws.com/pub.angelleague.io/fast_cut_front/challenge/short_form_image19.jpg')",
            }}
          ></div>
        </>
      )}

      {(!userInfo ||
        userInfo?.userType === UserType.체험 ||
        userInfo?.userType === UserType.USER) && (
        <div className="flex flex-col py-8 w-full">
          <div className="caution 4 w-full flex gap-4  mt-8 justify-center">
            <button
              className="md:w-full w-[335px] text-[18px] h-[60px] rounded-[60px] font-bold"
              style={{
                background:
                  'linear-gradient(to top, rgba(229, 169, 7, 1),rgba(237, 224, 147, 1))',
                border: '2px solid rgba(255, 255, 255 , 0.4)',
              }}
              onClick={() => {
                getPaymentOrderRequests(5, 10)
              }}
            >
              숏폼 스페셜 플랜 60% 할인받기 {`>`}
            </button>
          </div>
        </div>
      )}
    </>
  )
}
